// This file is owned by you (Plasmic never overwrites it on sync).
// ButtonPrimary keeps its Plasmic design untouched and gains an OPTIONAL
// "window button" behaviour: pass a `windowId` and the button opens /
// restores / minimizes / focuses that Desktop window, exactly like
// OP1WebButtonAppWindow. Without `windowId` it behaves as before.
//
// While it controls a window the root <button> also gets:
//   data-state="closed" | "open" | "active"
//   data-open, data-focused, aria-pressed
// so CSS (or a parent) can react to the window's state.
import * as React from "react";
import { PlasmicButtonPrimary } from "./plasmic/one_platform/PlasmicButtonPrimary";
import useWindowButton from "./useWindowButton";

function ButtonPrimary_({ windowId, onClick, ...props }, ref) {
  const { enabled, state, isOpen, isFocused, handleClick } =
    useWindowButton(windowId);

  // Keep any onClick wired up in Studio working: run it, then the window
  // action. When neither exists, pass nothing so Plasmic's output is unchanged.
  const composedOnClick =
    enabled || onClick
      ? (...args) => {
          onClick?.(...args);
          handleClick();
        }
      : undefined;

  const windowProps = enabled
    ? {
        "data-state": state,
        "data-open": isOpen,
        "data-focused": isFocused,
        "aria-pressed": state === "active",
      }
    : {};

  return (
    <PlasmicButtonPrimary
      globalBlue={{ ref }}
      {...props}
      {...windowProps}
      onClick={composedOnClick}
    />
  );
}

const ButtonPrimary = React.forwardRef(ButtonPrimary_);

export default ButtonPrimary;
